// @ts-nocheck

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import DatePicker from "react-multi-date-picker";
import moment from "moment";
import { frameList, LISTSONG, WISHLISTS } from "constants/common";

const HomePageView = (props) => {
  const {
    valueDate,
    setIsShowModalWhishNote,
    setIsShowModalSuccessNote,
    wishContent,
    setWishContent,
    wishActive,
    setWishActive,
    songActive,
    _onClickSong,
    isPlayAudio,
    setPlayAudio,
    audioCurrentTimeRef,
    audioRef,
    isValidWishContent,
    frameActive,
    setFrameActive,
  } = props;

  const navigate = useNavigate();
  const showModalWhish = () => {
    setIsShowModalWhishNote(true);
  };
  const showModalSaveNote = () => {
    setIsShowModalWhishNote(true);
  };
  const showModalSuccessNote = () => {
    setIsShowModalSuccessNote(true);
  };
  const [textAreaCount, ChangeTextAreaCount] = React.useState(
    wishContent.length
  );

  const recalculate = (e) => {
    ChangeTextAreaCount(e.length);
  };

  useEffect(() => {
    console.log("valueDate", valueDate);
    if (valueDate !== undefined) {
      props.setValue(
        "birthday",
        moment(valueDate).format("YYYY-MM-DD").toString()
      );
    } else {
      props.setValue("birthday", "");
    }
  }, [valueDate]);

  useEffect(() => {
    ChangeTextAreaCount(wishContent.length);
  }, [wishContent]);
  const ImageNameFromId = frameList.find(
    (item) => item.id === frameActive
  )?.name;
  return (
    <section>
      <div className="container">
        <div className="step1">
          <img className="gift-item" src="assets/img/gift-item-3.png" alt="" />

          <img
            className="img-full"
            src="assets/img/Title-bar-1.png"
            alt="line-bt"
          />
          <div className="bgr-border" id="joinNow">
            <div className="content-music">
              <p>Chọn 1 bài hát để tặng trước khi qua bước 2</p>
              <div
                className="checkbox-item"
                onClick={(e) => {
                  e.preventDefault();
                  _onClickSong(1);
                }}
              >
                <label
                  htmlFor="age1"
                  className={songActive === 1 ? "active" : ""}
                >
                  <input
                    checked={songActive === 1}
                    type="radio"
                    id="age1"
                    name="age"
                    value="30"
                  />{" "}
                  <span className="checkmark"></span>
                  {songActive === 1 && (
                    <span
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                        e.preventDefault();
                        if (!isPlayAudio) {
                          if (!audioRef.current) {
                            audioRef.current = new Audio(
                              LISTSONG.find((elm) => elm.id === 1).link
                            );
                          }
                          audioRef.current.currentTime =
                            audioCurrentTimeRef.current;
                          audioRef.current.play();
                          audioRef.current.addEventListener(
                            "ended",
                            function () {
                              audioRef.current.currentTime = 0;
                              audioCurrentTimeRef.currentTime = 0;
                            }
                          );
                        } else {
                          try {
                            audioCurrentTimeRef.current =
                              audioRef.current.currentTime;
                            audioRef.current.pause();
                          } catch (error) {}
                        }
                        setPlayAudio((old) => !old);
                      }}
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                    ></span>
                  )}
                  <div className="item-music">
                    <img src="assets/img/imusic.png" alt=" " />
                    <div>
                      <h4>Bài hát 1</h4>
                      {songActive === 1 && isPlayAudio && (
                        <img class src="assets/img/music.gif" alt=" " />
                      )}
                    </div>
                  </div>
                </label>
              </div>
              <div
                className="checkbox-item"
                onClick={(e) => {
                  e.preventDefault();
                  _onClickSong(2);
                }}
              >
                <label
                  htmlFor="age2"
                  className={songActive === 2 ? "active" : ""}
                >
                  <input
                    checked={songActive === 2}
                    type="radio"
                    id="age2"
                    name="age"
                    value="60"
                  />
                  <span className="checkmark"></span>
                  {songActive === 2 && (
                    <span
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                        e.preventDefault();
                        if (!isPlayAudio) {
                          if (!audioRef.current) {
                            audioRef.current = new Audio(
                              LISTSONG.find((elm) => elm.id === 2).link
                            );
                          }
                          audioRef.current.currentTime =
                            audioCurrentTimeRef.current;
                          audioRef.current.play();
                          audioRef.current.addEventListener(
                            "ended",
                            function () {
                              audioRef.current.currentTime = 0;
                              audioCurrentTimeRef.currentTime = 0;
                            }
                          );
                        } else {
                          try {
                            audioCurrentTimeRef.current =
                              audioRef.current.currentTime;
                            audioRef.current.pause();
                          } catch (error) {}
                        }
                        setPlayAudio((old) => !old);
                      }}
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                    ></span>
                  )}
                  <div className="item-music">
                    <img src="assets/img/imusic.png" alt=" " />
                    <div>
                      <h4>Bài hát 2</h4>
                      {songActive === 2 && isPlayAudio && (
                        <img class src="assets/img/music.gif" alt=" " />
                      )}
                    </div>
                  </div>
                </label>
              </div>
              <div
                className="checkbox-item"
                onClick={(e) => {
                  e.preventDefault();
                  _onClickSong(3);
                }}
              >
                <label
                  htmlFor="age3"
                  className={songActive === 3 ? "active" : ""}
                >
                  <input
                    checked={songActive === 3}
                    type="radio"
                    id="age3"
                    name="age"
                    value="100"
                  />
                  <span className="checkmark"></span>
                  {songActive === 3 && (
                    <span
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                        e.preventDefault();
                        if (!isPlayAudio) {
                          if (!audioRef.current) {
                            audioRef.current = new Audio(
                              LISTSONG.find((elm) => elm.id === 3).link
                            );
                          }
                          audioRef.current.currentTime =
                            audioCurrentTimeRef.current;
                          audioRef.current.play();
                          audioRef.current.addEventListener(
                            "ended",
                            function () {
                              audioRef.current.currentTime = 0;
                              audioCurrentTimeRef.currentTime = 0;
                            }
                          );
                        } else {
                          try {
                            audioCurrentTimeRef.current =
                              audioRef.current.currentTime;
                            audioRef.current.pause();
                          } catch (error) {}
                        }
                        setPlayAudio((old) => !old);
                      }}
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                    ></span>
                  )}
                  <div className="item-music">
                    <img src="assets/img/imusic.png" alt=" " />
                    <div>
                      <h4>Bài hát 3</h4>
                      {songActive === 3 && isPlayAudio && (
                        <img class src="assets/img/music.gif" alt=" " />
                      )}
                    </div>
                  </div>
                </label>
              </div>
              <div
                className="checkbox-item"
                onClick={(e) => {
                  e.preventDefault();
                  _onClickSong(4);
                }}
              >
                <label
                  htmlFor="age4"
                  className={songActive === 4 ? "active" : ""}
                >
                  <input
                    checked={songActive === 4}
                    type="radio"
                    id="age4"
                    name="age"
                    value="100"
                  />
                  <span className="checkmark"></span>
                  {songActive === 4 && (
                    <span
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                        e.preventDefault();
                        if (!isPlayAudio) {
                          if (!audioRef.current) {
                            audioRef.current = new Audio(
                              LISTSONG.find((elm) => elm.id === 4).link
                            );
                          }
                          audioRef.current.currentTime =
                            audioCurrentTimeRef.current;
                          audioRef.current.play();
                          audioRef.current.addEventListener(
                            "ended",
                            function () {
                              audioRef.current.currentTime = 0;
                              audioCurrentTimeRef.currentTime = 0;
                            }
                          );
                        } else {
                          try {
                            audioCurrentTimeRef.current =
                              audioRef.current.currentTime;
                            audioRef.current.pause();
                          } catch (error) {}
                        }
                        setPlayAudio((old) => !old);
                      }}
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                    ></span>
                  )}
                  <div className="item-music">
                    <img src="assets/img/imusic.png" alt=" " />
                    <div>
                      <h4>Bài hát 4</h4>
                      {songActive === 4 && isPlayAudio && (
                        <img class src="assets/img/music.gif" alt=" " />
                      )}
                    </div>
                  </div>
                </label>
              </div>
              <div
                className="checkbox-item"
                onClick={(e) => {
                  e.preventDefault();
                  _onClickSong(5);
                }}
              >
                <label
                  htmlFor="age5"
                  className={songActive === 5 ? "active" : ""}
                >
                  <input
                    checked={songActive === 5}
                    type="radio"
                    id="age5"
                    name="age"
                    value="100"
                  />
                  <span className="checkmark"></span>
                  {songActive === 5 && (
                    <span
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                        e.preventDefault();
                        if (!isPlayAudio) {
                          if (!audioRef.current) {
                            audioRef.current = new Audio(
                              LISTSONG.find((elm) => elm.id === 5).link
                            );
                          }
                          audioRef.current.currentTime =
                            audioCurrentTimeRef.current;
                          audioRef.current.play();
                          audioRef.current.addEventListener(
                            "ended",
                            function () {
                              audioRef.current.currentTime = 0;
                              audioCurrentTimeRef.currentTime = 0;
                            }
                          );
                        } else {
                          try {
                            audioCurrentTimeRef.current =
                              audioRef.current.currentTime;
                            audioRef.current.pause();
                          } catch (error) {}
                        }
                        setPlayAudio((old) => !old);
                      }}
                      className={
                        isPlayAudio ? "line-play-music" : "line-pause-music"
                      }
                    ></span>
                  )}
                  <div className="item-music">
                    <img src="assets/img/imusic.png" alt=" " />
                    <div>
                      <h4>Bài hát 5</h4>
                      {songActive === 5 && isPlayAudio && (
                        <img class src="assets/img/music.gif" alt=" " />
                      )}
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="step2">
          <img className="gift-item" src="assets/img/gift-item-4.png" alt="" />

          <img
            className="img-full"
            src="assets/img/Title-bar-2.png"
            alt="line-bt"
          />
          <div className="bgr-border">
            <div className="content-block">
              <p>
                Nhập/Hoặc điều chỉnh lời chúc ở ô dưới này để gửi đến người bạn
                yêu quý:
              </p>
              <div className="form-group">
                <div class="textAreaCount">
                  <p>{textAreaCount}/260</p>
                  <textarea
                    id="w3review"
                    placeholder=""
                    className="form-control"
                    name="w3review"
                    rows="4"
                    cols="50"
                    maxLength={260}
                    value={wishContent}
                    onChange={(e) => {
                      recalculate(e.target.value);
                      setWishContent(e.target.value);
                    }}
                  />
                </div>
                {isValidWishContent && (
                  <p className="text-error">
                    Vui lòng không nhập những từ ngữ kích động, nhạy cảm, bị hạn
                    chế...
                  </p>
                )}
              </div>
              {/* <button
              type="submit"
              className={`btn btn-primary btn-block btn-md btn-border ${
                isValidWishContent || wishContent.length === 0 ? "disable" : ""
              }`}
              onClick={() => {
                props.showModalWhish();
              }}
            >
              Xem trước lời chúc
            </button> */}
              {/* <p className="title-notedemo">Lời chúc mẫu</p>
            <div className="list-option">
              <ul>
                <li
                  onClick={() => {
                    setWishActive("default");
                    setWishContent(
                      WISHLISTS.find((elm) => elm.obj === "default")
                        ?.description
                    );
                  }}
                  className={wishActive === "default" ? "active" : ""}
                >
                  Mặc định
                </li>
                <li
                  onClick={() => {
                    setWishActive("mom");
                    setWishContent(
                      WISHLISTS.find((elm) => elm.obj === "mom")?.description
                    );
                  }}
                  className={wishActive === "mom" ? "active" : ""}
                >
                  Mẹ
                </li>
                <li
                  onClick={() => {
                    setWishActive("sister");
                    setWishContent(
                      WISHLISTS.find((elm) => elm.obj === "sister")?.description
                    );
                  }}
                  className={wishActive === "sister" ? "active" : ""}
                >
                  Chị
                </li>
                <li
                  onClick={() => {
                    setWishActive("love");
                    setWishContent(
                      WISHLISTS.find((elm) => elm.obj === "love")?.description
                    );
                  }}
                  className={wishActive === "love" ? "active" : ""}
                >
                  Người yêu
                </li>
                <li
                  onClick={() => {
                    setWishActive("friend");
                    setWishContent(
                      WISHLISTS.find((elm) => elm.obj === "friend")?.description
                    );
                  }}
                  className={wishActive === "friend" ? "active" : ""}
                >
                  Bạn bè
                </li>
              </ul>
            </div> */}
              <div className="group-btn-inline"></div>
            </div>
          </div>
        </div>
        <div className="step3">
          <img className="gift-item" src="assets/img/gift-item-1.png" alt="" />
          <img
            className="img-full"
            src="assets/img/Title-bar-4.png"
            alt="line-bt"
          />
          <div className="bgr-border">
            <div className="content-block">
              <p>Bản xem trước</p>
              <div className="preview-frame">
                <img src={`/assets/img/${ImageNameFromId}`} />

                <div className="content-wish">
                  <p >{wishContent}</p>
                </div>
              </div>

              <p className="title-notedemo">Chọn khung hình</p>
              <div className="list-option list-frame">
                <ul>
                  {frameList.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => {
                        setFrameActive(item.id);
                      }}
                      className={frameActive === item.id ? "active" : ""}
                    >
                      <img src={`/assets/img/${item.name}`} />
                    </li>
                  ))}
                </ul>
              </div>
              <div className="line"></div>
              <div className="group-btn-inline">
                <button
                  type="submit"
                  className={`btn btn-primary btn-block btn-border ${
                    isValidWishContent ||
                    wishContent?.length === 0 ||
                    !wishContent?.trim()?.length
                      ? "disable"
                      : ""
                  }`}
                  onClick={() => {
                    props.showModalSaveNote();
                  }}
                >
                  Lưu nháp
                </button>
                <button
                  type="submit"
                  className={`btn btn-primary btn-block ${
                    isValidWishContent ||
                    wishContent?.length === 0 ||
                    !wishContent?.trim()?.length
                      ? "disable"
                      : ""
                  }`}
                  onClick={() => {
                    props.showModalSuccessNote();
                  }}
                >
                  Hoàn Thành
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="step4">
          <img className="gift-item" src="assets/img/gift-item-2.png" alt="" />

          <img
            className="img-full"
            src="assets/img/Title-bar-3.png"
            alt="line-bt"
          />
          <p className="note-guide">
            Cùng gửi lời chúc đến người bạn yêu quý...
          </p>
          <div className="guide">
            <ul>
              <li>
                <div className="content-step">
                  <div className="step">Bước 1</div>
                  <p>Quét mã QR trên sticker</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 2</div>
                  <p>Chọn bài nhạc nền để phát khi người nhận đọc lời chúc</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 3</div>
                  <p>Nhập lời chúc gửi đến người bạn yêu quý</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 4</div>
                  <p>Chọn khung lời chúc theo mẫu có sẵn</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 5</div>
                  <p>
                    Lưu bản nháp để chỉnh sửa sau hoặc Xác nhận để hoàn thành
                    lời chúc
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
export default HomePageView;
